import { SimNaoEnum } from 'components/form'
import { MChatInput } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'

import { ConsultaSeguimentoPerguntasMap } from './consultaSeguimentoPerguntasMap'
import { ConsultaSeguimentoFieldModel, PassouFalhouEnum, PodeNaoPodeEnum } from './model-consultaSeguimento'

export const convertConsultaSeguimentoToInput = (
  consultaSeguimento: ConsultaSeguimentoFieldModel
): MChatInput['aplicacaoMChatRf'] => {
  if (isEmpty(consultaSeguimento)) return null
  return Object.entries(consultaSeguimento.aplicacao).flatMap(([pergunta, resposta]) => {
    const { convertToInput } = ConsultaSeguimentoPerguntasMap[pergunta]
    return convertToInput(resposta)
  })
}

export const convertSimNaoEnumToBoolean = (value: SimNaoEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === SimNaoEnum.SIM
}

export const convertPodeNaoPodeEnumToBoolean = (value: PodeNaoPodeEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === PodeNaoPodeEnum.PODE
}

export const convertPassouFalhouEnumToBoolean = (value: PassouFalhouEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === PassouFalhouEnum.PASSOU
}
